export const ActionType = {
  SET_TOKEN: 'SET_TOKEN',
  RESET_TOKEN: 'RESET_TOKEN'
};